import { COMPONENT_LABELS } from '../components/ui';

const URGENCY_LINE = {
  critical: 'Critical — needed within hours',
  high: 'Urgent — needed within 24 hours',
  normal: 'Needed soon',
};

/**
 * The message shared for a blood request.
 *
 * Deliberately limited to what a logged-out visitor is allowed to see: blood
 * type, component, units, urgency, city, and the link. No patient name, no
 * hospital name, no street address — the same fields `_to_public_out` in
 * routers/requests.py strips for anonymous viewers, so the platform doesn't
 * become a public record of who is in which hospital.
 *
 * That redaction matters more here than on the page: a forwarded WhatsApp
 * message travels through group chats the patient never agreed to, and whoever
 * taps the link arrives logged-out anyway — so anything extra in the message
 * would show them more than the page they land on.
 */
export function requestShareText(request) {
  const component = request.component && request.component !== 'whole_blood'
    ? ` (${COMPONENT_LABELS[request.component] || request.component})`
    : '';
  const units = request.units_needed
    ? `${request.units_needed} unit${request.units_needed > 1 ? 's' : ''}`
    : null;

  return [
    `🩸 ${request.blood_type} blood needed${component} in ${request.city}`,
    [units, URGENCY_LINE[request.urgency]].filter(Boolean).join(' · '),
    '',
    'Can you help, or pass this to someone who can?',
    requestUrl(request),
  ].filter(v => v !== null).join('\n');
}

export function requestUrl(request) {
  // Built from the origin rather than window.location.href so the link is
  // canonical — no ?redirect= or other query junk carried into the message.
  return `${window.location.origin}/requests/${request.id}`;
}

/**
 * wa.me rather than the whatsapp:// scheme: this one works from the mobile app,
 * WhatsApp Web and desktop, where whatsapp:// silently fails on desktop
 * browsers with nothing registered to handle it.
 */
export function whatsappShareUrl(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}
